import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsSideModalComponent } from "./ds-side-modal.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";

@NgModule({
  declarations: [DsSideModalComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsSideModalComponent],
})
export class DsSideModalModule {}
